import { Routes } from '@angular/router';

import { LandingComponent } from './components/landing/landing.component';
import landingRouteData from './components/landing/route-data';

export default <Routes>[
  {
    path: '',
    component: LandingComponent,
    data: landingRouteData
  }
];